import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  BRAND_SETTINGS_CTA: `${cleanedFilename(__filename)}-brand-settings-cta`,
  BRAND_SETTINGS_CTA_BUTTON: `${cleanedFilename(__filename)}-brand-settings-cta_button`,
};
